import { RouteObject } from "react-router-dom";

const dmsRoutes: RouteObject[] = [
	{
		path: "dms",
		lazy: () => import("@/pages/Page"),
		children: [
			{ index: true, lazy: () => import("@/pages/NotFoundPage") },
			{ path: "dokumenti", lazy: () => import("@/pages/DMS/DocumentsPage") },
			{ path: "dokumenti/vrsta-dokumenta/:documentTypeId", lazy: () => import("@/pages/DMS/DocumentsPage") },
			{ path: "dokumenti/:documentId", lazy: () => import("@/pages/DMS/DocumentDetailsPage") },
			{
				path: "vrste-dokumenata",
				children: [
					{ path: "", lazy: () => import("@/pages/DMS/DocumentTypesPage") },
					{ path: ":documentTypeId", lazy: () => import("@/pages/DMS/DocumentTypeDetailsPage") }
				]
			},
			{
				path: "predlosci-dokumenata",
				children: [
					{ path: "", lazy: () => import("@/pages/DMS/DocumentTypeTemplatesPage") },
					{
						path: ":documentTypeTemplateId",
						lazy: () => import("@/pages/DocumentTypes/DocumentTypeTemplateDetailsPage")
					}
				]
			},
			{ path: "mape/:nodeId?", lazy: () => import("@/pages/DMS/DocumentCollectionsPage") }
		]
	}
];

export default dmsRoutes;
